import { EDITORIAL_ACCESS_STATUS } from 'app/models/editorialAccess';
import React from 'react';

export const initialEditorialAccessState = { status: EDITORIAL_ACCESS_STATUS.idle, data: null };
export const EditorialAccessContext = React.createContext(initialEditorialAccessState);
export function useEditorialAccess() {
  return React.useContext(EditorialAccessContext);
}
